// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__wpd86","_specific":"styles__specific__iOmOk","active":"styles_active__1ecQ6","selectArea":"styles_selectArea__JVBSw","header":"styles_header___3ieR"};